import { ref } from "vue";
import * as htmlToImage from "html-to-image";

export function useCardDownload() {
  const copied = ref(false);

  const captureCard = async (cardId) => {
    const element = document.getElementById(`results-card-${cardId}`);
    if (!element) return null;

    const ringClasses = ["ring-2", "ring-inset", "ring-primary"];
    const hadRing = ringClasses.every((c) => element.classList.contains(c));
    if (hadRing) ringClasses.forEach((c) => element.classList.remove(c));

    try {
      const blob = await htmlToImage.toBlob(element, {
        backgroundColor: "#ffffff",
        pixelRatio: 2,
        filter: (node) => !node.classList?.contains("card-toolbar"),
      });
      return blob;
    } finally {
      if (hadRing) ringClasses.forEach((c) => element.classList.add(c));
    }
  };

  const downloadCardAsImage = async (cardId, filename) => {
    try {
      const blob = await captureCard(cardId);
      if (!blob) return;

      const url = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.download = `${filename || "card"}.png`;
      link.href = url;
      link.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Failed to download card image:", err);
    }
  };

  const copyCardToClipboard = async (cardId) => {
    try {
      const blob = await captureCard(cardId);
      if (!blob) return;

      await navigator.clipboard.write([new ClipboardItem({ "image/png": blob })]);
      copied.value = true;
      setTimeout(() => { copied.value = false; }, 2000);
    } catch (err) {
      console.error("Failed to copy card image:", err);
    }
  };

  return { downloadCardAsImage, copyCardToClipboard, copied };
}
